export default [
  // 车辆解绑
  {
    path: '/myCar-unbinding',
    component: () => import('@/views/myCar/unbinding/Index.vue'),
    name: 'myCar-unbinding',
    meta: {
      translateKey: 'cfmoto.applyUnbinding',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // 车辆解绑结果
  {
    path: '/myCar-unbinding-result',
    component: () => import('@/views/myCar/unbinding/Result.vue'),
    name: 'myCar-unbinding-result',
    meta: {
      translateKey: 'cfmoto.applyUnbinding',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-light-gray',
    },
  },
  // 车联网-智能网联功能介绍
  {
    path: '/myCar-iov-tboxIntro',
    component: () => import('@/views/myCar/iov/TboxIntro.vue'),
    name: 'myCar-iov-tboxIntro',
    meta: {
      translateKey: 'cfmoto.serviceIntroduction',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车联网-智能网联功能介绍
  {
    path: '/myCar-iov-tboxIntro1',
    component: () => import('@/views/myCar/iov/TboxIntro1.vue'),
    name: 'myCar-iov-tboxIntro1',
    meta: {
      translateKey: 'cfmoto.serviceIntroduction',
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车联网-绑定tbox设备
  {
    path: '/myCar-iov-tboxBind',
    component: () => import('@/views/myCar/iov/TboxBind.vue'),
    name: 'myCar-iov-tboxBind',
    meta: {
      translateKey: 'cfmoto.bindDevice',
      appName: 'BindNoTBoxDevice', // 实际要跳到APP页面
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 模式设置-编辑
  {
    path: '/myCar-modeSetting-index',
    component: () => import('@/views/myCar/modeSetting/Index.vue'),
    name: 'myCar-modeSetting-index',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-gray',
    },
  },
  // 模式设置-登录
  {
    path: '/myCar-modeSetting-login',
    component: () => import('@/views/myCar/modeSetting/Login.vue'),
    name: 'myCar-modeSetting-login',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
];
